import * as fromActions from '../actions/derivacion.action';
import { DerivacionData } from '../models/store.model';

export const derivacionInitialState: DerivacionData | null = null;

export function derivacionDataReducer(
    state = derivacionInitialState,
    action: fromActions.DerivacionDataActions
): DerivacionData | null {
    switch (action.type) {
        case fromActions.SETDERIVACIONDATA:
            return { ...action.derivacion };

        case fromActions.UNSETDERIVACIONDATA:
            return null;

        default:
            return state;
    }
}
